type MessageEventHandler = () => void;

class MessageEventEmitter {
  private listeners: MessageEventHandler[] = [];

  subscribe(handler: MessageEventHandler) {
    this.listeners.push(handler);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== handler);
    };
  }

  emit() {
    this.listeners.forEach(handler => handler());
  }
}

export const messageEvents = new MessageEventEmitter();

// Helper functions to emit events
export const notifyMessageSent = () => {
  messageEvents.emit();
};

export const notifyMessageReceived = () => {
  messageEvents.emit();
}; 